import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useEditCtaContext } from "../../../../../../context/EditCtaContext";

const ContentOneImageUpload = () => {
  const { formData, setFormData } = useEditCtaContext();
  const [preview, setPreview] = useState(null);

  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData((prevFormData) => ({
            ...prevFormData,
            contentImageOne: file,
            contentImageOnePreview: reader.result,
          }));
          setPreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    },
    [setFormData]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: "image/*",
  });

  return (
    <div className="flex flex-col items-center justify-center w-full mt-4">
      <div
        {...getRootProps()}
        className={`flex flex-col items-center justify-center w-full h-64 p-4 cursor-pointer bg-[#5E5D60] rounded-lg ${
          isDragActive ? "border-purple-500" : "border-gray-300"
        }`}
      >
        <input {...getInputProps()} />
        <div className="border-2 border-dashed rounded-lg h-full w-full">
          {preview ? (
            <img
              src={
                typeof formData.backgroundImage === "string"
                  ? formData.backgroundImage
                  : preview
              }
              alt="Preview"
              className="object-contain h-full w-full"
            />
          ) : (
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <svg
                className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                <span className="font-semibold">Click to upload</span> or drag
                and drop
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400">
                SVG, PNG, JPG or GIF (MAX. 800x400px)
              </p>
            </div>
          )}
        </div>
      </div>
      <p className="text-sm text-gray-400 mt-2">Recommended Size 394 x 1080</p>
    </div>
  );
};

export default ContentOneImageUpload;
